export const ACCEPTED_FILE_TYPES = 'audio/*,video/*';
